(function () {
    'use strict';

    var module = angular.module('imApp');

    module.component('epMenu', {
        templateUrl: 'views/components/views/epMenu/epMenu.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', function (stateService) {
            var vm = this;

            vm.model = {
                name: stateService.getCurrentName()
            };
        }]
    });
})();